var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInstagram(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 16,
    viewBox: "0 0 15 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.8333 0C13.1345 0 15 1.98985 15 4.44444V11.5556C15 14.0101 13.1345 16 10.8333 16H4.16667C1.86548 16 0 14.0101 0 11.5556L0 4.44444C0 1.98985 1.86548 0 4.16667 0L10.8333 0ZM10.8333 1.77778L4.16667 1.77778C2.78596 1.77778 1.66667 2.97169 1.66667 4.44444L1.66667 11.5556C1.66667 13.0284 2.78596 14.2222 4.16667 14.2222H10.8333C12.2141 14.2222 13.3333 13.0284 13.3333 11.5556V4.44444C13.3333 2.97169 12.2141 1.77778 10.8333 1.77778ZM7.5 4.44444C9.34092 4.44444 10.8333 6.03632 10.8333 8C10.8333 9.96364 9.34092 11.5556 7.5 11.5556C5.65905 11.5556 4.16667 9.96364 4.16667 8C4.16667 6.03632 5.65905 4.44444 7.5 4.44444ZM7.5 6.22222C6.5795 6.22222 5.83333 7.01813 5.83333 8C5.83333 8.98187 6.5795 9.77778 7.5 9.77778C8.4205 9.77778 9.16667 8.98187 9.16667 8C9.16667 7.01813 8.4205 6.22222 7.5 6.22222ZM11.25 3.11111C11.7102 3.11111 12.0833 3.50908 12.0833 4C12.0833 4.49092 11.7102 4.88889 11.25 4.88889C10.7897 4.88889 10.4167 4.49092 10.4167 4C10.4167 3.50908 10.7897 3.11111 11.25 3.11111Z",
    fill: "#103680"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInstagram);
export default __webpack_public_path__ + "static/media/instagram.780ced4060b08796418ff43bddc77154.svg";
export { ForwardRef as ReactComponent };